import { getAppStore } from '@/store';
import { ScreenType } from '@/types/analytics';
import { Screen } from '@/types';
import { isMobile } from '@/consts/device';

const getScreenType = (): ScreenType => {
  const { screen, resultFile } = getAppStore();

  switch (screen) {
    case Screen.Library:
      return ScreenType.CHOOSER;
    case Screen.Create:
      if (resultFile) return ScreenType.PREVIEW;
      return isMobile ? ScreenType.PRESET_FEED : ScreenType.GENERATOR;
    case Screen.Files:
      return ScreenType.HISTORY;
    case Screen.Loading:
      return ScreenType.GENERATOR;
    default:
      return ScreenType.GENERATOR;
  }
};

export default getScreenType;
